import _ from 'lodash';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { connect } from 'react-redux';
import notificationPopUp from '../../../NotificationPopUp';

import ConfirmationModal from '../../common/ConfirmationModal';
import TariffGroupModal from './TariffGroupModal';
import TextInput from '../../common/TextInput';

import * as authenticationActions from '../../../actions/authenticationActions';
import * as tariffActions from '../../../actions/tariffActions';

class TariffGroupsPage extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            authenticationState: this.props.authenticationState,
            commonState: this.props.commonState,
            pagingModel: this.props.pagingModel,
            tariffGroupDeleteModal: {
                show: false,
                dropRowKeysp: []
            },
            updateTariffGroupModal: {
                show: false,
                tariffGroup: { id: '', name: '', code: '' }
            }
        };

        if (!authenticationActions.verifyAuthentication(this.state.authenticationState, this.props.history)) {
            return;
        }
    }

    componentDidMount() {
        this.search(this.state.pagingModel);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.authenticationState !== prevState.authenticationState || nextProps.commonState !== prevState.commonState ||
            nextProps.pagingModel !== prevState.pagingModel) {
            const appPaginModel = Object.assign({}, prevState.pagingModel,
                {
                    items: nextProps.pagingModel.items,
                    page: nextProps.pagingModel.page,
                    itemsPerPage: nextProps.pagingModel.itemsPerPage,
                    total: nextProps.pagingModel.total
                });
            return Object.assign({}, prevState, { authenticationState: nextProps.authenticationState, commonState: nextProps.commonState, pagingModel: appPaginModel });
        }
        return null;
    }

    gridOnRowClick = (row) => {
        this.updateTariffGroupToggle(row);
    }

    onPageChange = (page, sizePerPage) => {
        var nPaging = Object.assign({}, this.state.pagingModel, { page: page, itemsPerPage: sizePerPage });
        this.search(nPaging);
    }

    onSortChange = (sortName, sortOrder) => {
        var nPaging = Object.assign({}, this.state.pagingModel, { sortName: sortName, sortOrder: sortOrder });
        this.search(nPaging);
    }

    saveTariffGroup = () => {
        if (_.isNil(this.state.updateTariffGroupModal.tariffGroup.name) || _.isEmpty(this.state.updateTariffGroupModal.tariffGroup.name) ||
            this.state.updateTariffGroupModal.tariffGroup.name.length < 5) {
            notificationPopUp.warning('Nome Gruppo non valido: deve avere una lunghezza maggiore d 4 caratteri');
            return;
        }

        if (_.isNil(this.state.updateTariffGroupModal.tariffGroup.code) || _.isEmpty(this.state.updateTariffGroupModal.tariffGroup.code) ||
            this.state.updateTariffGroupModal.tariffGroup.code.length < 5) {
            notificationPopUp.warning('Codice Gruppo non valido: deve avere una lunghezza maggiore d 4 caratteri');
            return;
        }

        this.props.actions.saveTariffGroup(this.state.updateTariffGroupModal.tariffGroup).then(() => {
            notificationPopUp.success('Gruppo Salvato');
            this.updateTariffGroupToggle({ id: '', name: '' });
        }).catch(error => {
            notificationPopUp.error(error);
        });
    }

    search = (pagingModel) => {
        if (_.isNil(pagingModel))
            pagingModel = this.state.pagingModel;

        this.props.actions.loadTariffGroups(pagingModel).then(() => {
        }).catch(error => {
            notificationPopUp.error('Problemi nel caricamento dei Gruppi dei Piani Mutualistici');
        });
    }

    showHideTariffGroupDeleteModal = (dropRowKeys) => {
        const tariffGroupDeleteModal = Object.assign({}, this.state.tariffGroupDeleteModal);
        tariffGroupDeleteModal.show = !tariffGroupDeleteModal.show;
        tariffGroupDeleteModal.dropRowKeysp = dropRowKeys;
        this.setState(Object.assign({}, this.state, { tariffGroupDeleteModal }));
    }

    tariffGroupConfirmDelete = (next, dropRowKeys) => {
        this.showHideTariffGroupDeleteModal(dropRowKeys);
    }

    tariffGroupDelete = (ids) => {
        this.props.actions.deleteTariffGroup(ids[0]).then(() => {
            notificationPopUp.success('Gruppo Eliminato');
            this.showHideTariffGroupDeleteModal([]);
        }).catch(error => {
            notificationPopUp.error(error);
        });
    }

    tariffGroupInsertButton = () => {
        return (<button type="button" className="btn btn-info react-bs-table-add-btn" onClick={() => this.updateTariffGroupToggle()}>
            <span><i className="glyphicon glyphicon-plus"></i>Aggiungi</span>
        </button>);
    }

    updateFilters = (event) => {
        const pagingModel = Object.assign({}, this.state.pagingModel);
        pagingModel[event.target.name] = event.target.value;
        this.setState(Object.assign({}, this.state, { pagingModel }));
    }

    updateTariffGroup = (event) => {
        const state = Object.assign({}, this.state);
        state.updateTariffGroupModal.tariffGroup[event.target.name] = event.target.value;
        this.setState(state);
    }

    updateTariffGroupToggle = (obj) => {
        if (_.isNil(obj))
            obj = { id: '', name: '' };

        const updateTariffGroupModal = Object.assign({}, this.state.updateTariffGroupModal);
        updateTariffGroupModal.show = !updateTariffGroupModal.show;
        updateTariffGroupModal.tariffGroup = obj;
        this.setState(Object.assign({}, this.state, { updateTariffGroupModal }));
    }

    render() {
        const gridOptions = {
            insertBtn: this.tariffGroupInsertButton,
            sizePerPage: this.state.pagingModel.itemsPerPage,
            page: this.state.pagingModel.page,
            sizePerPageList: [5, 10, 20, 50],
            onRowClick: this.gridOnRowClick,
            onPageChange: this.onPageChange,
            onSortChange: this.onSortChange,
            deleteText: 'Elimina',
            handleConfirmDeleteRow: this.tariffGroupConfirmDelete
        };

        return (
            <div className='container-fluid'>
                <h1>Gestione Gruppi Piani Mutualistici</h1>
                <div className="row panel panel-default x-panel-gray">
                    <div className="panel-heading">Filtri</div>
                    <div className="panel-body">
                        <Row>
                            <Col xs={12} md={4}>
                                <TextInput
                                    label='Denominazione'
                                    name='name'
                                    onChange={this.updateFilters}
                                    value={this.state.pagingModel.name} />
                            </Col>
                            <Col xs={12} md={4}>
                                <TextInput
                                    label='Codice'
                                    name='code'
                                    onChange={this.updateFilters}
                                    value={this.state.pagingModel.code} />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={4}>
                                <Button bsStyle='primary' onClick={() => this.search(Object.assign({}, this.state.pagingModel, { page: 1 }))} >Cerca</Button>
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="row">
                    <BootstrapTable data={this.state.pagingModel.items} fetchInfo={{ dataTotalSize: this.state.pagingModel.total }}
                        options={gridOptions} selectRow={{ mode: 'radio' }} deleteRow insertRow remote striped hover pagination>
                        <TableHeaderColumn isKey dataField='id' hidden>Id</TableHeaderColumn>
                        <TableHeaderColumn dataField='code' width={'20%'} dataSort>Codice</TableHeaderColumn>
                        <TableHeaderColumn dataField='name' width={'80%'} dataSort>Denominazione</TableHeaderColumn>
                    </BootstrapTable>
                </div>
                <ConfirmationModal
                    title='Conferma Eliminazione Grupppo'
                    message={'Sei sicuro di voler eliminare il Gruppo selezionato?'}
                    show={this.state.tariffGroupDeleteModal.show}
                    showHide={this.showHideTariffGroupDeleteModal}
                    action={() => this.tariffGroupDelete(this.state.tariffGroupDeleteModal.dropRowKeysp)}
                    commonState={this.state.commonState} />
                <TariffGroupModal
                    authenticationState={this.state.authenticationState}
                    commonState={this.state.commonState}
                    onChange={this.updateTariffGroup}
                    saveTariffGroup={this.saveTariffGroup}
                    tariffGroupModalObj={this.state.updateTariffGroupModal}
                    toggle={this.updateTariffGroupToggle}
                />
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        authenticationState: state.authenticationState,
        commonState: state.commonState,
        pagingModel: state.tariffGroupState
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(tariffActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TariffGroupsPage);
